import axios, { type Method } from 'axios';
import { API_URL } from '@/config';

const trimTrailingSlash = (url: string) => {
  if (url.endsWith('/')) {
    return url.slice(0, -1);
  }
  return url;
};

const trimLeadingSlash = (url: string) => {
  if (url.startsWith('/')) {
    return url.slice(1);
  }
  return url;
};

type RequestOptions = {
  url?: string;
  endpoint?: string;
  method?: Method;
  headers?: Record<string, string>;
  params?: Record<
    string,
    string | number | boolean | (string | number)[] | null | undefined
  >;
  body?: any;
};

export const apiRequest = async <T>({
  url,
  endpoint,
  method,
  headers,
  params,
  body: data,
}: RequestOptions = {}): Promise<T> => {
  const normalizedUrl = endpoint
    ? `${trimTrailingSlash(API_URL)}/${trimLeadingSlash(endpoint)}`
    : url;

  const response = await axios.request<T>({
    url: normalizedUrl,
    method: method || (data ? 'POST' : 'GET'),
    headers,
    params,
    data,
    withCredentials: true,
  });

  return response.data;
};
